import { MedalIcon } from '@/components/icons'
import React, { useEffect, useState } from 'react'

interface ScoreDetailsCardProps {
  loserInfo?: any
  rank?: any
  score?: any
  noOfGames?: any
  bye?: any
  forfeited?: any
}

const ScoreDetailsCard: React.FC<ScoreDetailsCardProps> = ({ loserInfo, rank, score, noOfGames, bye, forfeited }) => {
  const [matchScoreTeamOne, setMatchScoreTeamOne] = useState<any>([])
  const [matchScoreTeamTwo, setMatchScoreTeamTwo] = useState<any>([])

  useEffect(() => {
    let team1Scores = [...Array(noOfGames)]
      .map((_, id) => score[0][`game${id + 1}`])
      .map((el) => {
        if (el === -1) {
          return ''
        }
        return el
      })
    let team2Scores = [...Array(noOfGames)]
      .map((_, id) => score[1][`game${id + 1}`])
      .map((el) => {
        if (el === -1) {
          return ''
        }
        return el
      })
    const games = Math.min(team1Scores.length, team2Scores.length)
    team1Scores = team1Scores.slice(0, games)
    team2Scores = team2Scores.slice(0, games)

    // setValidGames(games);
    setMatchScoreTeamOne(team1Scores)
    setMatchScoreTeamTwo(team2Scores)
  }, [noOfGames, score])

  return (
    <div className="flex gap-x-2 py-2 items-center">
      {rank <= 3 ? (
        <MedalIcon
          className={`w-6 h-6 ${rank === 1 ? 'text-[#fd9a28]' : rank === 2 ? 'text-[#e8e8ed]' : 'text-[#e86769]'}`}
        />
      ) : null}
      <div className="flex gap-x-1 justify-center flex-1">
        {!bye && !forfeited ? (
          <>
            {noOfGames > 0 &&
              [...Array(noOfGames)].map((_, index) => (
                <div key={`${index + 1}`} className="flex gap-x-1">
                  <p className="text-gray-400">
                    {matchScoreTeamOne[index]}-{matchScoreTeamTwo[index]}
                  </p>
                  {noOfGames - (index + 1) > 0 ? <div className="border-r-[2px] border-r-slate-400" /> : null}
                </div>
              ))}
          </>
        ) : bye ? (
          <p className="text-slate-400 text-sm">BYE</p>
        ) : (
          <p className="text-slate-400 text-sm">FORFEITED</p>
        )}
      </div>
      <h6 className="text-sm text-boldOrange font-medium">{loserInfo}</h6>
    </div>
  )
}

export default ScoreDetailsCard
